import { API_ENDPOINTS } from "../config/config";
import apiClient, { apiRequest } from "./apiClient";

/**
 * Organization Service
 * Handles all organization-related API calls
 */

/**
 * Fetch Organization Details
 * Calls: GET /api/v1/organizations
 * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
 */
export const getOrganization = async () => {
  return apiRequest(
    () => apiClient.get(API_ENDPOINTS.ORGANIZATIONS),
    "Failed to fetch organization details"
  );
};

/**
 * Get Organization Logo URL
 * Returns the endpoint URL (auth should be added via headers in fetch)
 * @returns {string} Logo endpoint URL
 */
export const getOrganizationLogoUrl = () => {
  return API_ENDPOINTS.ORGANIZATION_LOGO;
};

/**
 * Upload Organization Logo
 * Calls: POST /api/v1/organizations/logo
 * @param {File} file - Logo image file (png/jpeg/webp)
 * @param {string} org_slug - Optional organization slug
 * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
 */
export const uploadOrganizationLogo = async (file, org_slug = null) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    if (org_slug) {
      formData.append("org_slug", org_slug);
    }

    const response = await apiClient.post(
      API_ENDPOINTS.ORGANIZATION_LOGO,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error("Upload logo error:", error);
    return {
      success: false,
      message:
        error.response?.data?.detail ||
        "Failed to upload logo. Please try again."
    };
  }
};
